module.exports = __webpack_public_path__ + "img/42.7ec82853.jpg";